import axios from 'axios'

export default class BaseApi {
  constructor () {
    this.axios = axios.create({
      baseURL: process.env.VUE_APP_API_URL
    })
  }

  get defaultPostHeaders () {
    return {
      'Content-Type': 'multipart/form-data'
    }
  }
}
